import {Route, Routes} from 'react-router-dom';

import {List} from './List';
import {Create} from './Create';
import {Update} from './Update';

export default function CauHinhHoaDon() {

  return (
    <Routes>
      <Route path="/" element={<List/>}/>
      <Route path="create" element={<Create/>}/>
      <Route path="update/:id" element={<Update/>}/>
    </Routes>
  );
}
